import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { initializeMsal } from './authConfig';

// Ally UX: cascade layers, tokens, the base reset and the Ally Flex utilities, in the documented order.
// Our own CSS below is unlayered, so it wins over all of them. fonts.css is skipped (Inter comes from
// public/index.html). Components are Ally UX's (unstyled PrimeReact underneath), so no PrimeReact theme loads.
import '@allygpo/ally-ux/layer-order.css';
import '@allygpo/ally-ux/foundations.css';
import '@allygpo/ally-ux/base.css';
import '@allygpo/ally-ux/ally-flex.css';
import 'primeicons/primeicons.css';

// Application imports
import './index.css';
import './components/ui/ui.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initializeMsal().then(msalInstance => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
});


reportWebVitals();
